const themes = {
    light: '/themes/light.css',
    dark: '/themes/dark.css',
};

export default themes;